import { inject } from "@angular/core";
import { Route, Routes } from "@angular/router";
import { CanActivateLoginGuard } from "app.services/login/services/can.activate.login.provider";
import { AuthenticatedMode } from "app/app.module";
import { ShellAuthGuard } from "../shell/services/shell-auth-guard";
import { DEV_ONLY_ROUTES } from "./dev_only_routes";

// loading asynchronously in AOT using a load function is extremely complex.
// we are forced to use the standard "loadChildren" using the string path parameter to obtain the
// angular AOT webpack plugin.
// is is a limitation for using lazy loading of custom bundles and we workaround it using the __webpack_public_path__
// hack above.
// if we want to go back and use it, we probably want to give chunk scripts a file name which contains the chunk name
// export function loadAppSession() : any{
// 	return new Promise(function (resolve,reject) {
// 		(require as any).ensure([], function (require: any) {
// 			resolve(require('./shell/shell.module')['ShellModule']);
// 		}, function () {
// 			reject({ loadChunkError: true });
// 		}, 'app.session');
// 	});
// }

let resolveSetAuthenticatedMode = {
	'setInit': () => Promise.resolve(inject(AuthenticatedMode).mode = true)
};

export const ROUTES: Routes = [
	{
		path: 'forms',
		loadChildren: () => import('../shell/session/forms.engine/forms.engine.module').then(m => m.FormsEngineModule),
	},
	{
		path: 'app',
		loadChildren: () => import('../app.session.module').then(m => m.AppSessionModule),
		canActivate: [ShellAuthGuard],
		canLoad: [ShellAuthGuard],
		resolve: resolveSetAuthenticatedMode
	},
	{
		path: 'login',
		loadChildren: () => import( /* webpackChunkName: "login" */  '../../app.services/login/login.module').then(m => m.LoginModule),
		canActivate: [CanActivateLoginGuard]
	},
	// this has to be here, if we push it to the end of the array, it will not work
	...(DEV_ONLY_ROUTES.map((route) => {
		return <Route> Object.assign({}, route, { 'resolve': resolveSetAuthenticatedMode });
	})),
	{ path: '', redirectTo: "login", pathMatch: 'full' },
	{ path: '**', redirectTo: 'login', pathMatch: 'full' },
];
